import { inject, Injectable } from '@angular/core';
import { Config } from '../../environments/config.model';
import { HttpClient, HttpContext } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BYPASS_SPINNER } from '../core/interceptors/loading.interceptor';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private config: Config | undefined;
  private http = inject(HttpClient);

  constructor() {}

  loadConfig(url: string): Promise<void> {
    return new Promise((resolve) => {
      const context = new HttpContext().set(BYPASS_SPINNER, true);
      this.http.get<Config>(url, { context }).pipe(map(res => res))
        .subscribe(config => {
          this.config = config;
          // @ts-ignore
          resolve();
        });
    });
  }

  get(): Config {
    return this.config!;
  }
}
